module.exports = __webpack_public_path__ + "static/media/stockhausen_augen_19.91b5a1ab.jpg";